
import './App.css';
import Loginmodule from './Pages/Login-pages/Login';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from './Pages/Dashboard/Dashboard';
import QueryList from './Pages/QueryList/QueryList';
import QueryDetails from './Pages/ViewQuery/QueryDetails';
import Allquerydashboard from './Pages/AlqueryDashboard/Allquerydashboard';
import Allviewquerydetails from './Pages/Allviewquerydetails/Allviewquerydetails';
import Userprofile from './Pages/Userprofile/Userprofile';
import 'react-toastify/dist/ReactToastify.css';
function App() {
  return (
    <BrowserRouter>
    <Routes>
        <Route path='/' element={<Loginmodule />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/querylist/:queryid/:query_type" element={<QueryList />} />
        <Route path="/querydetails/:queryrequired" element={<QueryDetails />} />
        <Route path="/allquerydashboard/:alquerydashboard" element={<Allquerydashboard />} />
        <Route path="/allviewquerydetails/" element={<Allviewquerydetails />} />
        <Route path="/userprofile/:mainuserprofile" element={<Userprofile/>}/>    
    </Routes>
  </BrowserRouter>
  );
}

export default App;
